import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 60000, // 60초로 증가 (일괄 전달용)
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터 - 토큰 추가
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // FormData인 경우 Content-Type을 자동으로 설정하도록 제거
    if (config.data instanceof FormData) {
      console.log('🔍 FormData 감지됨, Content-Type 헤더 제거');
      delete config.headers['Content-Type'];
      console.log('🔍 최종 헤더:', config.headers);
    }
    
    // 인터셉터 비활성화 - 직접 절대 경로 사용
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터 - 에러 처리
api.interceptors.response.use(
  (response) => {
    // Blob 응답은 원본 응답 반환 (responseType: 'blob')
    if (response.config.responseType === 'blob') {
      console.log('🔍 Blob 응답 감지됨, 원본 응답 반환');
      return response;
    }
    
    // 파일 업로드 응답도 원본 응답 반환 (FormData)
    if (response.config.data instanceof FormData) {
      console.log('🔍 FormData 업로드 응답 감지됨, 원본 응답 반환');
      return response;
    }
    
    // 로그인 API만 특별 처리
    if (response.config.url === '/auth/login') {
      return response.data; // 로그인 응답 데이터만 반환
    }
    
    // 입금처리 API는 원본 응답 반환 (success 필드 보존)
    if (response.config.url && response.config.url.includes('/payment-actions')) {
      console.log('🔍 입금처리 API 응답 인터셉터:', response.data);
      console.log('🔍 입금처리 API 원본 응답:', response);
      console.log('🔍 입금처리 API 응답 상태:', response.status);
      console.log('🔍 입금처리 API 응답 데이터 타입:', typeof response.data);
      console.log('🔍 입금처리 API 응답 데이터 키들:', Object.keys(response.data || {}));
      console.log('🔍 입금처리 API 응답 데이터 내용:', JSON.stringify(response.data));
      console.log('🔍 입금처리 API 반환할 데이터:', response.data);
      console.log('🔍 입금처리 API 반환할 데이터 타입:', typeof response.data);
      console.log('🔍 입금처리 API 반환할 데이터 키들:', Object.keys(response.data || {}));
      console.log('🔍 입금처리 API 반환할 데이터 내용:', JSON.stringify(response.data));
      console.log('🔍 입금처리 API 반환할 데이터 검증:', response.data && response.data.success);
      console.log('🔍 입금처리 API 반환할 데이터 검증2:', response.data?.success);
      return response.data;
    }
    
    // 나머지 모든 API는 통일된 방식으로 처리
    // 연체관리 API: {success: true, data: [...]} → response.data 반환
    // RMC 대시보드 API: 직접 데이터 → response.data 반환
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      // 토큰이 만료되었거나 유효하지 않은 경우
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;




